<template>
  <div class="content-firms container-fluid">
    <div class="content-firms__chart row">
      <div v-if="content.chart" class="bubble-header col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 offset-sm-1 offset-md-2">
        <div class="bubble-header__title row">
          <div class="col-11 col-sm-12">
            <h3>
              {{ content.chart.title }} <br />
              <span class="font-weight-light">{{ content.chart.year }}</span>
            </h3>
          </div>
        </div>
        <div class="bubble-header__instructions row">
          <div class="col-xs-12 col-12 col-sm-12">
            <p>
              {{ content.chart.instruction }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 offset-sm-1 offset-md-2">
        <Bubble />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Firms',
  components: {
    Bubble: () => import('@/components/content/charts/Bubble.vue'),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.content-firms {
  &__chart {
    padding: 60px 0;
  }

  @media #{map-get($media-breakpoints, 'mobile')} {
    &__chart {
      padding: 30px 0;
    }
  }
}

.bubble-header {
  padding-bottom: 20px;
  h3 {
    font-size: 22px;
    line-height: 1.45;
    font-weight: 700;
  }

  &__instructions {
    padding-top: 5px;
  }
}
</style>
